

















































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import L from 'leaflet';
import { Favourite } from '@/models/Favourite';

@Component
export default class FavouriteManager extends Vue {

    public widthThresholdValue: number = 768;
    public heightThresholdValue: number = 415;
    public showDialog: boolean = false;
    public sendNotifications: boolean = false;

    public unsubscribe = this.$store.subscribeAction((action, state) => {
        if (action.type === 'initFavourites') {
            this.initFavourites();
        }
    });

    get map(): L.Map {
        return this.$store.state.map;
    }

    get isLoggedIn(): boolean {
        return this.$store.state.isLoggedIn;
    }

    get favourites(): Favourite[] {
        return this.$store.state.favourites.favourites;
    }

    get favouriteCount(): number {
        return this.$store.state.favourites.favouriteCount;
    }

    get isMobile(): boolean {
        return (this.$q.screen.width <= this.widthThresholdValue) || (this.$q.screen.height <= this.heightThresholdValue);
    }

    public listingStatusClass(status: any) {
        if (status === '1' || status === '1_0') {
            return 'listTblPrice_FORSALE';
        } else if (status === '2' || status === '2_0') {
            return 'listTblPrice_SOLD';
        } else if (status === '3' || status === '3_0') {
            return 'listTblPrice_PEND';
        }
        return 'listTblPrice_NOSTATUS';
    }

    public initFavourites() {
        console.log('FavouriteManager: initFavourites()');
        if (this.isLoggedIn) {
            this.$store.dispatch('getFavouriteSettings');
        }
    }

    public onShowDialog() {
        if (this.isLoggedIn) {
            if (this.favouriteCount !== this.favourites.length) {
                this.$store.dispatch('getFavoriteData');
            }
            this.sendNotifications = this.$store.state.favourites.favouriteNotifications;
            this.showDialog = true;
        } else {
            this.$store.dispatch('showLoginPromptDialog', 'You must login to view favourites.');
        }
    }

    public onGoToFavourite(systemId: number) {
        console.log('FavouriteManager: onGoToFavourite()');
        this.$store.dispatch('goToListing', systemId);
    }

    public onDeleteFavourite(systemId: number) {
        console.log('FavouriteManager: onDeleteFavourite()');
        this.$store.dispatch('favouriteRemove', systemId);
    }

    public onSendNotifications() {
        this.$store.dispatch('setFavouriteNotifications', this.sendNotifications);
    }

    public initFavControl() {
        // TODO this will go, moving away from leaflet...
        if (!this.isLoggedIn) {
            return;
        }

        const FavControl = L.Control.extend({
            options: {
                position: 'topright',
            },
            onAdd: () => {
                const container = L.DomUtil.create('div', 'divFavControl');
                container.innerHTML = `<span id='spanFavControl' class='spanFavControl' title='Favourites'>` +
                    `<i class='fas fa-heart fa-lg'></i>` +
                    `<div id='divFavCount' class='lblFavCount'></div>` +
                    `</span>`;
                return container;
            },
        });

        this.map.addControl(new FavControl());

        const favBtn = document.getElementById('spanFavControl');
        if (favBtn) {
            favBtn.addEventListener('click', (event) => {
                event.preventDefault();
                this.$store.dispatch('getFavoriteData');
                this.showDialog = true;
            });
        }
    }

}
